<template>
    <div class="bg-red">
        <div class="award-wrapper">
            <div class="frame">
                <p class="subtitle">
                    活動已經截止<br>
                    感謝消費者熱情參與
                </p>
                <h2 class="title">
                    <div class="circle">得</div>
                    <div class="circle">獎</div>
                    <div class="circle">名</div>
                    <div class="circle">單</div>
                </h2>
                <ul class="list">
                    <li v-for="(l, idx) in list" :key="idx"
                    >
                        <span class="name"
                        v-text="l.name"></span>
                        <span class="phone"
                        v-text="l.phone"></span>
                    </li>
                </ul>
                <div class="text-wrapper">
                    <p class="text">
                        親愛的日本獅王愛用者：
                    </p>
                    <p class="text">
                        感謝您參加「開運笑起來」活動，恭喜以下幸運得獎名單，獲得
                        【<span class="strong">酵素潔護牙膏</span> 及 <span class="strong">
                        酵素亮白牙膏</span>各一支(恕不挑選口味)】共 10 名！
                    </p>
                    <p class="text">
                        請得獎人收信填妥領獎憑證，詳閱注意事項，並於 2020/2/27 (四) 前寄回主辦單位 (以郵戳為憑)。
                    </p>
                    <p class="text">
                        主辦單位確認兌獎資料無誤後，將於2020/3/13 (五) 前陸續寄送獎項至得獎人填寫之獎項寄送地址。
                    </p>
                    <p class="text">
                        若有任何疑問，請洽本活動小組，<br>Email： events@design-edg.com；<br>聯絡電話：(02) 2729-6000 #104
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Award',
    data() {
        return {
            list: [
                {
                    name: '吳○美',
                    phone: '0955XXX331',
                },
                {
                    name: '朱○樺',
                    phone: '0955XXX331',
                },
                {
                    name: '魯○君',
                    phone: '0977XXX992',
                },
                {
                    name: '黃○恬',
                    phone: '0916XXX876',
                },
                {
                    name: '黃○萍',
                    phone: '0921XXX957',
                },
                {
                    name: '吳○羽',
                    phone: '0981XXX363',
                },
                {
                    name: '謝○妤',
                    phone: '0978XXX951',
                },
                {
                    name: '李○芬',
                    phone: '0931XXX920',
                },
                {
                    name: 'Nicole',
                    phone: '0938XXX382',
                },
                {
                    name: '黃○婷',
                    phone: '0911XXX331',
                },
            ],
        };
    },
};
</script>
